<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fIxYHs/tc-custom/9780795344190.jpg?1718106102382" alt="This image is the cover for the book Inside, Outside"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Inside, Outside
      </h1>
      <p class="bookDescription body article font2">
        <b>A “truly enjoyable” journey through one man’s Jewish American experience by the #1 <i>New York Times</i>-bestselling author</b><b>of <i>Marjorie Morningstar</i> (<i>Newsday</i>).</b><br/>  <br/> Israel David Goodkind is a minor bureaucrat in the Nixon White House, killing time in the office by writing the story of four generations of his large, sprawling Russian-Jewish immigrant family. As he recounts his brief stint in show business, his torrid affair with a showgirl, and his encounters with a hassled and distracted President Nixon, Goodkind also witnesses historical events firsthand—the Watergate scandal, the Yom Kippur War—and eventually finds his way back to his Jewish faith.<br/><br/> Combining Pulitzer Prize winner Herman Wouk’s wildly comic streak with his deep respect for religious tradition, Inside, Outside is both one man’s story and “a social comedy of Jewish-American life reaching from New York to Jerusalem and spanning much of the 20th century” (<i>Publishers Weekly</i>).<br/>  <br/> “Extremely funny.”—<i>The Wall Street Journal</i><br/>  <br/> “Wouk reaffirms his position as one of the nation’s eminent storytellers.”—<i>Newsday</i><br/>  <br/> “Wouk`s most significant work since <i>The Caine Mutiny</i>.”—<i>Chicago Tribune</i><br/>  <br/> “Generously stuffed with zestfully old-fashioned humor and sentiment.”—<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Herman Wouk
      </h2>
      
      <p class="authorDescription body article">Herman Wouk (1915&ndash;2019) was a Pulitzer Prize&ndash;winning author of fiction and nonfiction. His works include <I>The Caine Mutiny</I>,<I> Marjorie Morningstar</I>,<I> The Hope</I>, and<I> The Glory</I>. Several of his books have been adapted into films and miniseries. Wouk&rsquo;s early career as a radio comedy writer included a stint on the Fred Allen Show. He later became a naval officer after the attack on Pearl Harbor in 1941. The son of Russian Jewish immigrants, Wouk&rsquo;s novels <I>The Winds of War </I>and <I>War and Remembrance </I>delve into Jewish peoples experiences during World War II. In 1999, he received the Jewish Book Council Lifetime Achievement Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f49e2728